import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Breadcrumbs from "../../../reusebale/breadcrumbs";
import MaintainanceLoader from "../../../skeleton-loader/maintainance-detail";
import Chat from "./chat";
import OverviewRequest from "./overviewRequest";

import BaseUrl from "../../../../constants/BaseUrl";

const DetailMain = ({ onBack, recordId }) => {
  const [details, setDetails] = useState(null);
  const [tenantInfo, setTenantInfo] = useState(null);
  const [loading, setLoading] = useState(true); // Loader state
  const { loginSuccess } = useSelector((state) => state.auth);

  const GetTenantProfile = (id) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${BaseUrl}tenant/profile/getProfileDetails/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success") {
          setTenantInfo(result.data);
        }
      })
      .catch((error) => console.error(error));
  };

  const GetRecordDetails = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    setLoading(true); // Start loading
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/maintenence/getMaintanenceRequestDetails/${recordId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          GetTenantProfile(result?.data?.tenantId);
          setDetails(result?.data);
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setLoading(false); // Stop loading after API response
      });
  };

  useEffect(() => {
    if (recordId) {
      GetRecordDetails();
    }
  }, [recordId]);

  const GetRecordChatOnly = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/maintenence/getMaintanenceRequestDetails/${recordId}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setConversation(result?.data?.conversation);
        }
      })
      .catch((error) => console.error(error));
  };

  const [conversation, setConversation] = useState([]);

  const ChatUpdateHandler = (info) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);

    const raw = JSON.stringify({
      recordId: details?._id,
      sender: info.sender,
      text: info.text,
      senderType: info.senderType,
      time: info.time,
    });

    const requestOptions = {
      method: "PUT",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/maintenence/updateMaintenanceConversation`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 200) {
          GetRecordChatOnly();
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      GetRecordChatOnly();
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mt-4 h-full">
      <Breadcrumbs
        classes={`text-darkColor font-popinsSemiBold text-xl`}
        subheading="Maintenance Details"
        recordId={`MAIN-${details?._id?.slice(0, 10)}`}
        onBack={onBack}
      />
      {loading ? (
        <MaintainanceLoader />
      ) : (
        <div className="flex justify-between mt-4 h-full">
          <div className="w-[64%] h-screen overflow-scroll scrollbar-hide panelScroll">
            <OverviewRequest
              onRehit={GetRecordDetails}
              tenantInfo={tenantInfo}
              data={details}
            />
          </div>
          <div className="w-[34%] h-full">
            <Chat
              conversation={conversation}
              chatUpdateHandler={ChatUpdateHandler}
              recordDetails={details}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailMain;
